// This module provides a protected reference to underscore that won't be
// affected by external scripts (like PDF viewers or browser extensions) that
// override the global _ variable.
//
// webpack.ProvidePlugin automatically injects this wherever _ is used in our code.

import underscore from 'underscore';

export default underscore;
